"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSpotMaxQuantity = exports.selectPayingBalance = exports.selectOrderTypes = exports.selectOrderSide = exports.selectOrderPrice = exports.selectOrderNet = exports.selectOrderMaxQuantity = exports.selectOrderFormValues = exports.selectOrderFee = exports.selectMarketPrice = exports.selectMarginMaxQuantity = exports.selectLevel1ForInstrument = exports.selectIsBuyForm = exports.selectFuturesOrderFormValues = exports.selectDefaultFormValues = exports.selectAdvancedOrderFormValues = exports.orderTotalSelector = exports.hasCreditTierSelector = exports.getOrderFormValuesSelector = void 0;
var _reselect = require("reselect");
var _bignumber = require("bignumber.js");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _selectors = require("../../redux/margin/selectors");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _positionSelectors = require("../../redux/selectors/positionSelectors");
var _productsSelectors = require("./productsSelectors");
var _orderHelper = require("../../helpers/orderHelper");
var _config = _interopRequireDefault(require("../../config"));
var _placeOrderHelper = require("../../helpers/placeOrderHelper");
var _productPositionSelectors = require("./productPositionSelectors");
var _futuresSelectors = require("../futures/selectors/futuresSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var EMPTY_OBJECT = {};
var selectDefaultFormValues = exports.selectDefaultFormValues = function selectDefaultFormValues(formName) {
  return function (state) {
    var _state$form$formName$, _state$form$formName;
    return (_state$form$formName$ = (_state$form$formName = state.form[formName]) === null || _state$form$formName === void 0 ? void 0 : _state$form$formName.values) !== null && _state$form$formName$ !== void 0 ? _state$form$formName$ : EMPTY_OBJECT;
  };
};
var selectAdvancedOrderFormValues = exports.selectAdvancedOrderFormValues = function selectAdvancedOrderFormValues(state) {
  var _state$form$advancedO, _state$form$advancedO2;
  return (_state$form$advancedO = (_state$form$advancedO2 = state.form.advancedOrderEntry) === null || _state$form$advancedO2 === void 0 ? void 0 : _state$form$advancedO2.values) !== null && _state$form$advancedO !== void 0 ? _state$form$advancedO : EMPTY_OBJECT;
};
var selectFuturesOrderFormValues = exports.selectFuturesOrderFormValues = function selectFuturesOrderFormValues(state) {
  var _state$form$advancedO3, _state$form$advancedO4;
  return (_state$form$advancedO3 = (_state$form$advancedO4 = state.form.advancedOrderEntry) === null || _state$form$advancedO4 === void 0 ? void 0 : _state$form$advancedO4.values) !== null && _state$form$advancedO3 !== void 0 ? _state$form$advancedO3 : EMPTY_OBJECT;
};
var getOrderFormValuesSelector = exports.getOrderFormValuesSelector = function getOrderFormValuesSelector() {
  var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'orderEntry';
  if (formName === 'advancedOrderEntry') selectAdvancedOrderFormValues;
  if (formName === 'futuresOrderEntry') selectFuturesOrderFormValues;
  return selectDefaultFormValues(formName);
};
var selectOrderFormValues = exports.selectOrderFormValues = function selectOrderFormValues(state, _ref) {
  var formName = _ref.formName;
  return getOrderFormValuesSelector(formName)(state);
};
var selectOrderSide = exports.selectOrderSide = function selectOrderSide(state, props) {
  return selectOrderFormValues(state, props).side;
};
var selectIsBuyForm = exports.selectIsBuyForm = function selectIsBuyForm(state, props) {
  return selectOrderSide(state, props) === _orderEntryFormConstants.buyValue;
};
var selectOrderTypes = exports.selectOrderTypes = (0, _reselect.createSelector)(_selectors.isMarginActiveSelector, _futuresSelectors.isFuturesActiveSelector, function (_, orderFormTypes) {
  return orderFormTypes;
}, function (isMarginActive, isFuturesActive, orderFormTypes) {
  if (isFuturesActive) {
    return Object.values(orderFormTypes).filter(function (i) {
      return _config["default"].Trading.FuturesAllowedOrderTypes.includes(i.displayName);
    }).map(function (value) {
      return {
        value: value.displayName,
        label: value.displayName
      };
    });
  }
  return Object.values(orderFormTypes).filter(function (i) {
    return isMarginActive ? _config["default"].Trading.MarginAllowedOrderTypes.includes(i.displayName) : _config["default"].Trading.SpotAllowedOrderTypes.includes(i.displayName);
  }).map(function (value) {
    return {
      value: value.displayName,
      label: value.displayName
    };
  });
});
var selectLevel1ForInstrument = exports.selectLevel1ForInstrument = (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentSelector, function (state) {
  return state.apexCore.level1;
}], function (selectedInstrument, level1) {
  var _level1$selectedInstr;
  return (_level1$selectedInstr = level1 === null || level1 === void 0 ? void 0 : level1[selectedInstrument.InstrumentId]) !== null && _level1$selectedInstr !== void 0 ? _level1$selectedInstr : EMPTY_OBJECT;
});
var selectMarketPrice = exports.selectMarketPrice = (0, _reselect.createSelector)([selectLevel1ForInstrument, selectIsBuyForm], function (level1, isBuy) {
  var _level;
  return (_level = level1[isBuy ? 'BestOffer' : 'BestBid']) !== null && _level !== void 0 ? _level : 0;
});
var selectOrderPrice = exports.selectOrderPrice = (0, _reselect.createSelector)([selectOrderFormValues, selectMarketPrice], function (values, marketPrice) {
  switch (values.orderType) {
    case _orderEntryFormConstants.orderTypes.limit.displayName:
    case _orderEntryFormConstants.orderTypes.reserveOrder.displayName:
      return values.limitPrice;
    case _orderEntryFormConstants.orderTypes.stopMarket.displayName:
      return values.stopPrice;
    case _orderEntryFormConstants.orderTypes.stopLimit.displayName:
      return values.limitPrice;
    default:
      return marketPrice;
  }
});
var selectPayingBalance = exports.selectPayingBalance = (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentSelector, selectIsBuyForm, _positionSelectors.positionSelector], function (instrument, isBuy, positions) {
  var payingProductId = isBuy ? instrument.Product2 : instrument.Product1;
  var position = positions[payingProductId];
  return position ? position.Amount - position.Hold : 0;
});
var selectSpotMaxQuantity = exports.selectSpotMaxQuantity = (0, _reselect.createSelector)([selectPayingBalance, selectIsBuyForm, selectOrderPrice], function (balance, isBuy, orderPrice) {
  return isBuy ? orderPrice ? balance / orderPrice : 0 : balance;
});
var selectMarginMaxQuantity = exports.selectMarginMaxQuantity = (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentSelector, _selectors.marginAccountEquitySelector, _productsSelectors.decimalsByProductId], function (instrument, equity, decimals) {
  var _equity$MaxAmount, _decimals$instrument$;
  return new _bignumber.BigNumber((_equity$MaxAmount = equity.MaxAmount) !== null && _equity$MaxAmount !== void 0 ? _equity$MaxAmount : 0).dp((_decimals$instrument$ = decimals[instrument.Product1]) !== null && _decimals$instrument$ !== void 0 ? _decimals$instrument$ : 2).toNumber();
});
var selectOrderMaxQuantity = exports.selectOrderMaxQuantity = (0, _reselect.createSelector)([_selectors.isMarginActiveSelector, selectSpotMaxQuantity, selectMarginMaxQuantity], function (isMarginActive, spotMax, marginMax) {
  return isMarginActive ? marginMax : spotMax;
});
var orderTotalSelector = exports.orderTotalSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.level1;
}, function (state) {
  return state.apexCore.level2;
}, selectOrderFormValues], function (level1, level2, form) {
  var orderType = form.orderType,
    quantity = form.quantity,
    value = form.value,
    anchoredField = form.anchoredField,
    side = form.side,
    stopPrice = form.stopPrice,
    limitPrice = form.limitPrice,
    trailingAmount = form.trailingAmount,
    limitOffset = form.limitOffset;
  if (orderType === _orderEntryFormConstants.orderTypes.market.displayName) {
    var _config$OrderCalcBuff = _config["default"].OrderCalcBuffer,
      _config$OrderCalcBuff2 = _config$OrderCalcBuff === void 0 ? {} : _config$OrderCalcBuff,
      priceBuffer = _config$OrderCalcBuff2.priceBuffer;
    var orders = (0, _orderHelper.getOrdersBySide)(side, level2);

    // Over-ride for Market-by-value.
    if (anchoredField === 'value') {
      return value || 0;
    }
    var _getPriceForQuantity = (0, _orderHelper.getPriceForQuantity)(quantity, priceBuffer, orders, true, side),
      Price = _getPriceForQuantity.Price;
    return _bignumber.BigNumber.isBigNumber(Price) ? Price.toNumber() : Price;
  }
  if (orderType === _orderEntryFormConstants.orderTypes.stopMarket.displayName) {
    var _price = new _bignumber.BigNumber(stopPrice);
    return _price.times(quantity).toNumber();
  }
  if (orderType === _orderEntryFormConstants.orderTypes.stopLimit.displayName) {
    var _price2 = new _bignumber.BigNumber(limitPrice);
    return _price2.times(quantity).toNumber();
  }
  if (orderType === _orderEntryFormConstants.orderTypes.trailingStopMarket.displayName) {
    var pegPrice = new _bignumber.BigNumber((0, _placeOrderHelper.getPegPriceByType)(level1, form));
    var _price3 = side === _orderEntryFormConstants.buyValue ? pegPrice.plus(trailingAmount) : pegPrice.minus(trailingAmount);
    return _price3.times(quantity).toNumber();
  }
  if (orderType === _orderEntryFormConstants.orderTypes.trailingStopLimit.displayName) {
    var _pegPrice = new _bignumber.BigNumber((0, _placeOrderHelper.getPegPriceByType)(level1, form));
    var _price4 = side === _orderEntryFormConstants.buyValue ? _pegPrice.plus(trailingAmount).plus(limitOffset) : _pegPrice.minus(trailingAmount).minus(limitOffset);
    return _price4.times(quantity).toNumber();
  }
  if (orderType === _orderEntryFormConstants.orderTypes.reportBlockTrade.displayName) {
    var _price5 = new _bignumber.BigNumber(form.price || '0');
    if (form.useNewForm) {
      return _price5.times(quantity).toNumber();
    }
    return side === _orderEntryFormConstants.buyValue ? _price5.toNumber() : Number(quantity);
  }

  // Default:
  var price = new _bignumber.BigNumber(limitPrice);
  return price.times(quantity).toNumber();
});
var selectOrderNet = exports.selectOrderNet = (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentSelector, selectOrderFormValues, selectLevel1ForInstrument, orderTotalSelector, _selectors.isMarginActiveSelector], function (instrument, formValues, level1, orderTotal, isMarginActive) {
  var _getOrderNet;
  return (_getOrderNet = (0, _orderHelper.getOrderNet)(formValues, instrument, orderTotal, true, level1, false, isMarginActive)) !== null && _getOrderNet !== void 0 ? _getOrderNet : 0;
});
var selectOrderFee = exports.selectOrderFee = (0, _reselect.createSelector)([selectOrderFormValues, _productPositionSelectors.productsSelector], function (formValues, products) {
  return (0, _orderHelper.getOrderFee)(formValues, products);
});
var hasCreditTierSelector = exports.hasCreditTierSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.selectedAccountId;
}, function (accounts, selectedAccountId) {
  var mainAccount = accounts.find(function (x) {
    return x.AccountId === selectedAccountId;
  });
  if (mainAccount) {
    return mainAccount.RiskType === 'Credit';
  }
  return false;
});